goog.provide("shadow.js.shim.module$$tiptap$extension_list");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_list");
shadow.js.shim.module$$tiptap$extension_list = shadow.js.nativeProvides["@tiptap/extension-list"] = shadow$bridge("@tiptap/extension-list");
module$shadow_js_shim_module$$tiptap$extension_list.default = shadow.js.shim.module$$tiptap$extension_list;
